import { createSelector } from 'reselect';

import { createSelectorFactory } from 'wanderu-ducks-utils';

import { selectAppStateSlice } from '../../selectors';
import NAMESPACE from './types';

function selectData(state) {
    return selectAppStateSlice(state)[NAMESPACE];
}

function selectRawPolicies(state, carrierCode) {
    return selectData(state)[carrierCode];
}

function mapPolicy(policy, code) {
    if (!policy) {
        return undefined;
    }

    return {
        ...policy?.policies,
        code,
    };
}

function mapMultiplePolicies(data, carrierCodes) {
    return carrierCodes?.map((carrierCode) => {
        const policy = data[carrierCode];

        return mapPolicy(policy, carrierCode);
    });
}

function selectPoliciesFactory(carrierCodes) {
    if (!carrierCodes) {
        return undefined;
    }

    if (typeof carrierCodes === 'string') {
        return createSelector(
            (state) => selectRawPolicies(state, carrierCodes),
            (policy) => mapPolicy(policy, carrierCodes),
        );
    }

    return createSelector(
        selectData,
        (data) => mapMultiplePolicies(data, carrierCodes),
    );
}
const selectPolicies = createSelectorFactory(selectPoliciesFactory);

const selectAllPolicies = createSelector(
    selectData,
    (allPolicies) => {
        return Object.entries(allPolicies)
            .reduce((policies, [code, policy]) => ({
                ...policies,
                [code]: mapPolicy(policy, code),
            }), {});
    },
);

export {
    selectAllPolicies,
    selectPolicies,
};
